import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import cx from 'clsx';
import { Tooltip } from '@kcd/design-system';

import { ADDRESS_ROUTER } from '~/constants/router';
import {
  useAddressTooltipMessage,
  useDefaultShippingAddress,
} from '~/domains/address/queries';
import { openPageModal } from '~/utils/mobileApp';

import { MapIcon } from '~/assets/icons';

import styles from './index.module.css';

function AddressContent({
  children,
  tooltipMessage,
}: {
  children: React.ReactNode;
  tooltipMessage?: string;
}) {
  const addressChildren = (
    <div className={styles.address}>
      <MapIcon />
      <div>{children}</div>
    </div>
  );

  return (
    <div className={styles.container} data-dd-privacy="mask">
      {tooltipMessage ? (
        <Tooltip
          initialVisibility
          placement="bottom-left"
          textAlign="text-center"
          className={styles.tooltipContent}
          description={tooltipMessage}
        >
          {addressChildren}
        </Tooltip>
      ) : (
        addressChildren
      )}
      <button
        type="button"
        className={styles.action}
        onClick={() => openPageModal(ADDRESS_ROUTER.root)}
      >
        변경
      </button>
    </div>
  );
}

function AddressSelectorContent() {
  const address = useDefaultShippingAddress({ useErrorBoundary: true });
  const tooltipMessage = useAddressTooltipMessage();

  if (!address) {
    return (
      <button
        type="button"
        className={cx([styles.container, 'relative'])}
        onClick={() => openPageModal(ADDRESS_ROUTER.new())}
      >
        <div className={styles.address}>
          <MapIcon />
          <div>배송지를 등록하고 상품을 확인하세요.</div>
        </div>
        <p className={styles.tooltip}>
          현재 서울/경기 기준으로 상품을 보여드리고 있어요.
        </p>
        <span className={styles.action}>등록</span>
      </button>
    );
  }

  return (
    <AddressContent tooltipMessage={tooltipMessage}>
      <span className="pr-8 text-hint typo-paragraph100-regular">배송지</span>
      {address.displayAddress}
    </AddressContent>
  );
}

export default function AddressSelector() {
  return (
    <ErrorBoundary
      fallbackRender={() => <AddressContent>주소 불러오기 실패</AddressContent>}
    >
      <React.Suspense
        fallback={<AddressContent>주소 불러오는 중</AddressContent>}
      >
        <AddressSelectorContent />
      </React.Suspense>
    </ErrorBoundary>
  );
}
